import HomePageHeader from './HomePageHeader';

export default HomePageHeader;
